import * as React from "react";
import Paper from "@mui/material/Paper";
import CustomTextField from "../../components/Textfield";
import { Box } from "@mui/material";
import DashboardWrapper from "../../components/DashboardWrapper";
import FormDetail from "./FormDetail";
import { formateDate } from "../../utils/timeHelper";
import TableComponent from "../../components/Table";
// import { getContactForms } from "../../http/auth";
import Spinner from "../../components/Spinner";
import CustomSelectField from "../../components/Select";
import useDebounce from "../ManageUsers/useDebounce";

const columns = [
  { id: "sr", label: "Sl. No.", minWidth: 30 },
  { id: "name", label: "Name", minWidth: 80 },
  { id: "email", label: "Email", minWidth: 170 },
  { id: "date", label: "Submit Date", minWidth: 40 },
  { id: "view", label: "Action", minWidth: 40 },
];

function createData(
  sr,
  name,
  email,
  date,
  view,
  description,
  phone,
  attachments
) {
  return { sr, name, email, date, view, description, phone, attachments };
}

export default function ContactForms() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [searchString, setSearchString] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  // const [userType, setUserType] = React.useState("");
  const [nextId, setNextId] = React.useState("");

  const params = new URLSearchParams(document.location.search);
  const id = params.get("id");

  const debouncedSearchString = useDebounce(searchString, 300);

  React.useEffect(() => {
    getUserList(debouncedSearchString);
  }, [debouncedSearchString]);

  const getUserList = async (search) => {
    try {
      setLoading(true);
      const payload = {
        ...(nextId && { nextId }),
        ...(search && { search }),
      };
      const response = await getContactForms(payload);
      const resData = response.data?.data?.contactUs?.data;
      setNextId(response.data?.data?.contactUs?.nextId);

      if (resData) updateRows(resData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const updateRows = (resData) => {
    const currentCount = nextId ? rows.length : 0;
    const list = resData.map((item, index) => {
      return createData(
        currentCount + index + 1,
        item.name || "-",
        item.email || "-",
        formateDate(item.createdAt, "MMM DD, YYYY"),
        "",
        item.query,
        item.phone,
        item.attachments
      );
    });
    const updatedList = nextId ? [...rows, ...list] : list;
    setRows(updatedList);
  };

  const onNextClick = async () => {
    setPage(page + 1);
    if (nextId && page === rows.length / 10 - 1) {
      try {
        await getUserList(null, nextId);
      } catch (error) {
        console.log(error, "error");
      }
    }
  };

  const onPrevClick = async () => {
    setPage(page - 1);
  };

  const onChange = (event) => {
    setSearchString(event.target.value);
  };

  return (
    <DashboardWrapper userId={id}>
      <Paper
        sx={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
          boxSizing: "border-box",
          boxShadow: "none",
        }}
      >
        {id ? (
          <FormDetail />
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "4%",
              }}
            >
              <CustomTextField
                sx={{
                  width: "100%",
                  minWidth: "200px",
                  maxWidth: "400px",
                  "& .MuiInputBase-input": { padding: "9px 16px 9px 48px" },
                }}
                name="search"
                placeholder="Search"
                value={searchString}
                onChange={onChange}
                type="search"
              />
            </Box>
            {!loading ? (
              <TableComponent
                columns={columns}
                rows={rows}
                page={page}
                rowsPerPage={rowsPerPage}
                onPrevClick={onPrevClick}
                onNextClick={onNextClick}
              />
            ) : (
              <Spinner />
            )}
          </>
        )}
      </Paper>
    </DashboardWrapper>
  );
}
